export default "__VITE_ASSET__DcCSfcSK__"